<app-icon-button [icon]="icon" class="delete-button" [label]="label" [disabled]="disabled"></app-icon-button>
